/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Dialog, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { TypeForDialog, useReservationBookingOnlineContext } from 'pages/reservationBookingOnlineV2/context';
import React from 'react';
import useStyles from './styles';

const PrecautionForBodyToneDialogContent = () => {
  const classes = useStyles();
  return (
    <>
      <h3 className={classes.dialogTitle}>体調に関する注意</h3>
      <p className={classes.dialogContent}>
        お客様ならびに従業員の健康と安全を確保するため、下記に該当及び疑いのある方はご予約をお控えください。
        <br />
        ・風邪の症状(くしゃみ・咳・37.0度以上の発熱)がある方
        <br />
        ・強いだるさ(倦怠感)や息苦しさがある方 ・咳・痰、または胸部に不快感のある方
        <br />
        ・過去14日間以内に感染症流行地域等へ渡航及び当該渡航者と濃厚接触のある方
        <br />
        ・過去14日間以内に新型コロナウィルス感染者またはその疑いのある方と接触された方
        <br />
        ・その他新型コロナウィルス感染可能性の症状がある方
        <br />
        また、禁忌事項に該当する場合はご来店いただいてもケアをお断りする場合がございますので事前に「
        <a href="https://www.ci-z.com/important_points" style={{ color: '#cd0021' }} target="_blank" rel="noopener noreferrer">ご来店前に必ずお読みください</a>
        」を必ずご確認ください。
      </p>
    </>
  );
};

const AdultStudentUsingServiceDialogContent = () => {
  const classes = useStyles();
  return (
    <>
      <h3 className={classes.dialogTitle}>未成年・学生の方は必ずご確認ください</h3>
      <p className={classes.dialogContent}>
        未成年・学生の方は保護者に同伴いただくか、ご来店の際に親権者同意書をお持ちいただくか、保護者様へのお電話での確認が必要です。同意書は
        <a href="https://ci-z.com/wp-content/themes/ci-z/assets/pdf/side-pdf-01.pdf" style={{ color: '#cd0021' }} target="_blank" rel="noopener noreferrer">こちら</a>
        から。
      </p>
    </>
  );
};

const PaymentCompletedDialogContent = () => {
  const classes = useStyles();
  return (
    <>
      <h3 className={classes.dialogTitle}>受付完了</h3>
      <p className={classes.dialogContent}>
        仮予約お申込みを受け付けました。
        <br />
        24時間以内にお客様がご希望された店舗より、ご予約確認のお電話を差し上げます。
        <br />
        お電話が繋がらない場合は、誠に申し訳ございませんがご予約はキャンセルとなりますのであらかじめご了承願います。
      </p>
    </>
  );
};

const ReceivedAppointmentDateDialogContent = () => {
  const classes = useStyles();
  return (
    <>
      <h3 className={classes.dialogTitle}>予約日時のお問い合わせを受け付けました</h3>
      <p className={classes.dialogContent}>
        24時間以内にお客様がご希望された店舗より、お電話を差し上げます。
        <br />
        予約はリアルタイムで変動していきますので、空き状況に合わせてご案内させて頂きます。
      </p>
    </>
  );
};

const PrecautionBeforeApplicationDialogContent = () => {
  const classes = useStyles();
  return (
    <>
      <h3 className={classes.dialogTitle}>お申込み前のご注意</h3>
      <p className={classes.dialogContent}>
        お客様ならびに従業員の健康と安全を確保し、安心してご利用いただくために「
        <a href="https://www.ci-z.com/anshin.html" style={{ color: '#cd0021' }} target="_blank" rel="noopener noreferrer">安心してご利用頂くための取組</a>
        」を必ずご確認ください。
        <br />
        また、禁忌事項に該当する場合はご来店いただいてもトリートメントをお断りする場合がございますので事前に
        <a href="https://www.ci-z.com/important_points.html" style={{ color: '#cd0021' }} target="_blank" rel="noopener noreferrer">こちら</a>
        を必ずご確認ください。
        <br />
        ・お試しプランはお一人様１回限りご利用となります。
        <br />
        ・お客様の体質、体調等によりご希望のトリートメントがご提供できない場合がございます。
        <br />
        ・トリートメント内容によりご希望の日時に添えない場合がございます。
        <br />
        ・初回ご来店時には身分証明書のご提示をお願いしております。
        <br />
        ※当サロンでは、以下の方のご利用をお断りしております。
        <br />
        ・反社会的勢力(暴力団・暴力団関係企業等)これに準ずる団体に所属している方
        <br />
        ・刺青・タトゥー等のある場合。
        <br />
        ・酒気を帯びている方
        <br />
        ・他のお客様のご迷惑となる行為、危険な行為をされた方
        <br />
        ・その他、当サロンをご利用いただくのに相応しくない方、また相応しくないと当サロンが判断した方
        <br />
        ※当サロンでは、以下の方のご利用をお断りする場合があります。
        <br />
        ・刺青・タトゥー等のある場合。（4cm四方以内のものは1か所程度までは部位を避けてトリートメント) 。
        <br />
        また、上記対応範囲以内におきましても、ロッカールーム、メイクルーム等での共有スペースでは刺青(タトゥー)部位を衣類で覆う等、他のお客様へのご配慮を頂きますようお願いしております。
      </p>
    </>
  );
};


const DialogComponents = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { isDialogOpen, handleHideDialog, typeDialog } = useReservationBookingOnlineContext();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const renderContent = () => {
    switch (typeDialog) {
      case TypeForDialog.PRECAUTION_FOR_BODY:
        return <PrecautionForBodyToneDialogContent />;
      case TypeForDialog.ADULT_STUDENT_USING_SERVICE:
        return <AdultStudentUsingServiceDialogContent />;
      case TypeForDialog.PAYMENT_COMPLETED:
        return <PaymentCompletedDialogContent />;
      case TypeForDialog.RECEIVED_APPOINTMENT_DATE:
        return <ReceivedAppointmentDateDialogContent />;
      case TypeForDialog.PRECAUTION_BEFORE_APPLICATION:
        return <PrecautionBeforeApplicationDialogContent />;
      default:
        break;
    }
    return null;
  };

  const renderButton = () => {
    switch (typeDialog) {
      case TypeForDialog.PAYMENT_COMPLETED:
        return 'HOMEへ';
      default:
        return '閉じる';
    }
  };

  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleHideDialog}
      PaperProps={{ style: { borderRadius: 0, overflowY: 'unset', maxWidth: isMobile ? '400px' : '800px' } }}
    >
      <div className={classes.dialogContainer}>
        <div className={classes.btnCloseOutside} onClick={() => handleHideDialog()} />
        {/* Content Components Rendering */}
        {renderContent()}
        {/*  */}
        <div className={classes.dialogBtn}>
          <button type="button" onClick={() => handleHideDialog()}>
            {renderButton()}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default DialogComponents;
